import { Button, Card, Col, Form, InputGroup, OverlayTrigger, Row, Tooltip } from "react-bootstrap"
import Select from 'react-select'
import { SCREEN_SETTING } from "../../constants/screenRouter";
import { OBJECT_REWARD_ITEM, PLAYER_CONFIG, PLAYER_CONFIG_LABEL, PLAYER_CONFIG_QD_CHECKBOX, PLAYER_CONFIG_QD_NUMBER, PLAYER_CONFIG_TIP, PLAYER_CONFIG_TYPE_UI, TYPE_UI } from "../../constants/Common";
import { useEffect, useState } from "react";
import { configPlayer } from "../../services/authService";
import usePlayerConfig from "../../hooks/usePlayerConfig";
import useSettingScreen from "../../hooks/useSettingScreen";
import MoleculeCheckBoxAndInputNumber from "../../Molecule/MoleculeCheckBoxAndInputNumber";
import MoleculeCheckBoxAndSelectBox from "../../Molecule/MoleculeCheckBoxAndSelectBox";
import MoleculeCheckBox from "../../Molecule/MoleculeCheckBox";
import useOnlineInfo from "../../hooks/useOnlineInfo";
import { dropItemMap } from "../../constants/dropItemMap";
import MoleculeMultiSelectBox from "../../Molecule/MoleculeMultiSelectBox";

const SettingQuanDoan = ({ playerId }) => {
    const [stateconfigs, setStateconfigs] = useState({});
    const { configs, updateSingleConfig } = usePlayerConfig(playerId)
    const { gotoScreen } = useSettingScreen(playerId);
    const { online } = useOnlineInfo(playerId);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const groupOptions = [
        OBJECT_REWARD_ITEM,
        dropItemMap
    ]

    const handleSelected = (value) => {
        // console.log('handleSelected', value);
        setSelectedOptions(value)
        updateConfig(PLAYER_CONFIG.ID_OBJECT_LEGION_DROP_ITEM, formatSelectValueToConfig(value));
    }
    const formatConfigToSelectValue = (config) => {
        if (config instanceof Array) {
            const rewardItems = OBJECT_REWARD_ITEM.options.filter(option => config.includes(option.value));
            const dropItems = dropItemMap.options.filter(option => config.includes(option.value));
            return [...rewardItems, ...dropItems]
        } else return [];
    }
    const formatSelectValueToConfig = (selectedValue) => {
        const config = [];
        selectedValue.forEach(option => {
            config.push(option.value)
        });
        return config;
    }

    const updateConfig = (configId, value) => {
        setStateconfigs(prevConfigs => ({
            ...prevConfigs,
            [configId]: value
        }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log('handleSubmit', stateconfigs);
        const newConfig = { ...stateconfigs };
        newConfig[PLAYER_CONFIG.ID_START_GAME_AFTER_S] = stateconfigs[PLAYER_CONFIG.ID_START_GAME_AFTER_S] * 60
        // console.log("handleSubmit startgame", newConfig[PLAYER_CONFIG.ID_START_GAME_AFTER_S])
        configPlayer(playerId, newConfig);
        gotoScreen(playerId, SCREEN_SETTING.NO_OPEN);
    }
    useEffect(() => {
        for (const configId in configs) {
            if (configId == PLAYER_CONFIG.ID_PRIORITY_HAI_SAN) {
                // updateConfig(configId, [...configs[configId]])
            }
            else if (configId == PLAYER_CONFIG.ID_START_GAME_AFTER_S) {
                updateConfig(configId, Math.ceil(configs[configId] / 60));
            }
            else if (configId == PLAYER_CONFIG.ID_OBJECT_LEGION_DROP_ITEM) {
                updateConfig(configId, configs[configId]);
                setSelectedOptions(formatConfigToSelectValue(configs[configId]));
            }
            else updateConfig(configId, configs[configId]);
        }
    }, [configs])

    useEffect(() => {
        if (online == false) {
            gotoScreen(playerId, SCREEN_SETTING.NO_OPEN);
        }
    }, [online])
    return (
        <Card.Body>
            <Form onSubmit={handleSubmit}>
                <Row className="mt-3" >
                    <Col>
                        <Row xs={1} sm={2} md={3} lg={3}>
                            {
                                PLAYER_CONFIG_TYPE_UI.map(config => {
                                    if (config.TYPE == TYPE_UI.CHECK_BOX) {
                                        return (<MoleculeCheckBox
                                            key={`MoleculeCheckBox-${config.ID_1}`}
                                            label={PLAYER_CONFIG_LABEL[config.ID_1]}
                                            tooltip={PLAYER_CONFIG_TIP[config.ID_1]}
                                            value={stateconfigs[config.ID_1]}
                                            onChange={(newChecked) => updateConfig(config.ID_1, newChecked)}
                                        />)
                                    }
                                })
                            }
                        </Row>
                        <Row xs={1} sm={2} md={3} lg={3}>
                            {
                                PLAYER_CONFIG_TYPE_UI.map(config => {
                                    if (config.TYPE == TYPE_UI.CHECK_BOX_INPUT_NUMBER) {
                                        return (
                                            <MoleculeCheckBoxAndInputNumber
                                                key={`MoleculeCheckBoxAndInputNumber-${config.ID_1}`}
                                                cbLabel={PLAYER_CONFIG_LABEL[config.ID_1]}
                                                cbTooltip={PLAYER_CONFIG_TIP[config.ID_1]}
                                                cbValue={stateconfigs[config.ID_1]}
                                                cbOnChange={(newChecked) => updateConfig(config.ID_1, newChecked)}
                                                ipLabel={PLAYER_CONFIG_LABEL[config.ID_2]}
                                                ipTooltip={PLAYER_CONFIG_TIP[config.ID_2]}
                                                ipValue={stateconfigs[config.ID_2]}
                                                ipOnChange={(newChecked) => updateConfig(config.ID_2, newChecked)}
                                                ipMin={config.ID_2_MIN}
                                            />
                                        )
                                    }

                                })
                            }
                        </Row>
                    </Col>
                    <Col xs={3} sm={2} md={1} lg={1} className="d-flex align-items-center">
                        <Button className="mx-auto" variant="outline-primary" type="submit">Save</Button>
                    </Col>
                </Row>
                <Row className="mt-3">
                    {PLAYER_CONFIG_TYPE_UI.map(config => {
                        if (config.TYPE == TYPE_UI.SELECT_BOX) {
                            return (
                                <MoleculeMultiSelectBox
                                    label={PLAYER_CONFIG_LABEL[config.ID_1]}
                                    tooltip={PLAYER_CONFIG_TIP[config.ID_1]}
                                    options={groupOptions}
                                    placeholder="Tất cả"
                                    value={selectedOptions}
                                    onChange={(newValue) => handleSelected(newValue)} />
                            )
                        }
                    })
                    }
                </Row>
            </Form>
        </Card.Body>
    );
}

export default SettingQuanDoan;